import { LoginForm } from '../../../components/forms';

export const Login = () => {
  return (
    <div className="columns">
      <LoginForm />
    </div>
  );
};
